import React, {useEffect} from 'react';
import {compose} from 'redux';
import * as PropTypes from "prop-types";
import {withTranslation} from 'react-i18next';
import {Box, Button, Divider, FormControlLabel, FormGroup, Grid, Switch} from '@mui/material';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import FacetItemCheckbox from "./FacetItemCheckbox";
import MultiSelectTree from './MultiSelectTree';

const FacetComponent = ({t, facet, facetDistribution, choices, display, updateFacet}) => {
        const icons = {
            orientations: "compass",
            difficulties: 'tachometer-alt',
            guidebookIds: 'book',
            regionId: 'globe-europe',
        };

        const handleClear = (name) => {
            updateFacet(name, []);
        };

    useEffect(() => {

    }, [facet, choices]);

    const getFacetChoices = (choices, display) => {
        if (display?.sort && display.sort === 'alphanum') {
            return choices.sort(function(a, b) {
                if (a.hasOwnProperty('position')) {
                    return a.position - b.position;
                } else {
                    return a.label.localeCompare(b.label);
                }
            });
        }

        return choices;
    }

    return (<>
            {(Array.isArray(facet.choices) || facet.hasOwnProperty('treeFilter')) &&
            <>
                <Box display="flex" p={1} pb={0} alignItems="center">
                    <Box flexGrow={1}>
                        {icons.hasOwnProperty(facet.name) && <><FontAwesomeIcon icon={["fas", icons[facet.name]]}  className="primary" /> &nbsp;</>}
                        {t('FacetComponent.facet.' + facet.name)}
                    </Box>
                    {choices.length > 0 && display.type !== 'boolean' &&
                    <Box>
                        <Button onClick={() => {handleClear(facet.name)}}>
                            {t('FacetComponent.action.clear')}
                        </Button>
                    </Box>}

                    {display.type === 'boolean' && <Box sx={{marginBottom: 0}}>
                        <FormGroup row>
                            {getFacetChoices(facet.choices, display).map((choice, index) => {
                                if (choice.value === 'false') {
                                    return <></>;
                                }
                                const checked = choices.includes(choice.value) ? "checked" : null;
                                return  <FormControlLabel key={facet.name + '-' + choice.value} control={<Switch checked={checked}
                                                                           onChange={(event) => {

                                                                               if (!checked) {
                                                                                   if (choices.indexOf(choice.value) === -1) {
                                                                                       choices.push(choice.value);
                                                                                   }
                                                                               }

                                                                               if (checked && choices.indexOf(choice.value) !== -1) {
                                                                                   choices.splice(choices.indexOf(choice.value), 1);
                                                                               }

                                                                               updateFacet(facet.name, choices);
                                                                           }}/>}/>;
                            })}
                        </FormGroup>
                    </Box>}
                </Box>
                <Box display="flex" p={1}>
                    <Box flexGrow={1}>
                        {display.type === "multiple" &&
                        <FormGroup row>
                            <Grid container>
                                {getFacetChoices(facet.choices, display).map((choice, index) => {
                                    if (display.hasOwnProperty("hideEmpty") && display.hideEmpty && choice.count === 0) {
                                        return '';
                                    }
                                    const noneChecked = choices.length === 0;
                                    const checked = choices.includes(choice.value);
                                    let label = ((noneChecked || checked) && choice.count > 0) ? choice.label + ' (' + choice.count + ')' : choice.label;

                                    return (
                                        <Grid item xs={display.grid} key={index}>
                                            <FacetItemCheckbox
                                                checked={checked}
                                                label={label}
                                                name={facet.name}
                                                value={"" + choice.value}
                                                onCheckItem={(event, isChecked) => {
                                                    if (isChecked) {
                                                        if (choices.indexOf(choice.value) === -1) {
                                                            choices.push(choice.value);
                                                        }
                                                    }

                                                    if (!isChecked && choices.indexOf(choice.value) !== -1) {
                                                        choices.splice(choices.indexOf(choice.value), 1);
                                                    }

                                                    updateFacet(facet.name, choices);
                                                }}
                                            />
                                        </Grid>
                                    );
                                })}
                            </Grid>
                        </FormGroup>
                        }

                        {display.type === "tree" && <>
                            <MultiSelectTree
                                name={facet.name}
                                nodes={facet.treeFilter}
                                choices={choices}
                                choicesCount={facetDistribution}
                                updateChoices={updateFacet}/>
                        </>}

                        <Divider/>
                    </Box>
                </Box>
            </>
            }
        </>
    );
};

FacetComponent.defaultProps = {
    facet: PropTypes.object.isRequired,
    choices: PropTypes.array,
    display: PropTypes.object,
    updateFacet: PropTypes.func.isRequired,
};

export default compose(
        withTranslation()
    )(FacetComponent);
